var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252.45 299.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a0ee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pandora"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pandora-2",
    "data-name": "Pandora",
    className: "cls-1",
    d: "m0,0v299.38h80.31c7.47,0,13.53-6.06,13.53-13.53v-57.51h20.11c98.3,0,138.5-55.41,138.5-120.2-.01-79.98-60.79-108.14-117.98-108.14H0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandora);
export default __webpack_public_path__ + "static/media/Pandora.8551c720a0cd99d258229fbe7217ba2f.svg";
export { ForwardRef as ReactComponent };